import type { SVGProps } from "react";

export function Power(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99961 0.100098C7.33098 0.100098 7.59961 0.368727 7.59961 0.700098V6.7001C7.59961 7.03147 7.33098 7.3001 6.99961 7.3001C6.66824 7.3001 6.39961 7.03147 6.39961 6.7001V0.700098C6.39961 0.368727 6.66824 0.100098 6.99961 0.100098ZM3.32265 1.97461C3.55697 2.20893 3.55697 2.58883 3.32265 2.82314C1.29193 4.85387 1.29193 8.14633 3.32265 10.1771C5.35338 12.2078 8.64584 12.2078 10.6766 10.1771C12.7073 8.14633 12.7073 4.85387 10.6766 2.82314C10.4423 2.58883 10.4423 2.20893 10.6766 1.97461C10.9109 1.7403 11.2908 1.7403 11.5251 1.97461C14.0244 4.47397 14.0244 8.52623 11.5251 11.0256C9.02574 13.5249 4.97348 13.5249 2.47413 11.0256C-0.0252296 8.52623 -0.0252296 4.47397 2.47413 1.97461C2.70844 1.7403 3.08834 1.7403 3.32265 1.97461Z"
        fill="white"
      />
    </svg>
  );
}
